"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var INTERACTION_PREFIX = '__hook___bind__model__interaction';

var _default = function _default(model, field) {
  if (!model || !field) {
    return [null, function () {}];
  }

  var _useState = (0, _react.useState)(model.get(field)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      _setValue = _useState2[1],
      setter = function setter() {
    var interactionId = (0, _uniqueId["default"])(INTERACTION_PREFIX); // _setValue is "context" of useModel hook

    model[INTERACTION_PREFIX] = interactionId;
    _setValue[INTERACTION_PREFIX] = interactionId;

    _setValue.apply(void 0, arguments);
  };

  (0, _react.useEffect)(function () {
    model.set(field, value);
  }, [value]);
  (0, _react.useEffect)(function () {
    var _eventHandler = function _eventHandler() {
      if (model[INTERACTION_PREFIX] === undefined || _setValue[INTERACTION_PREFIX] === undefined || model[INTERACTION_PREFIX] !== _setValue[INTERACTION_PREFIX]) {
        _setValue(model.get(field));
      }

      if (_setValue[INTERACTION_PREFIX]) {
        delete _setValue[INTERACTION_PREFIX];
      }
    };

    model === null || model === void 0 ? void 0 : model.on("change:".concat(field), _eventHandler);
    return function () {
      model === null || model === void 0 ? void 0 : model.off("change:".concat(field), _eventHandler);
    };
  }, [field, model]);
  return [value, setter];
};

exports["default"] = _default;